import { css } from "@emotion/react";
import { Box, Typography } from "@mui/material";
import { FontFamily, FontWeight } from "@unit/styles";
import React from "react";
import { PiWarningCircle } from "react-icons/pi";

const SecurityWarning: React.FC = () => {
  return (
    <Box p={2} mt={2} css={style.container}>
      <Box display="flex" alignItems="center" gap={0.5} mb={2}>
        <PiWarningCircle size={30} />
        <Typography css={style.title}>認証に失敗しました</Typography>
      </Box>
      <Typography css={style.description}>
        認証コードの有効期限が切れているか、認証コードが誤っている可能性がございます。もう一度やり直してください。
      </Typography>
    </Box>
  );
};
export default SecurityWarning;

const style = {
  container: css`
    width: 100%;
    border: 1px solid #ff5555;
    border-radius: 8px;
    color: #ff5555;
    background-color: #fff7f6;
  `,
  title: css`
    font-family: ${FontFamily.kintoSans};
    font-weight: ${FontWeight.bold};
    font-size: 18px;
    line-height: 1;
  `,
  description: css`
    font-family: ${FontFamily.kintoSans};
    font-weight: ${FontWeight.medium};
    color: #596171;
    font-size: 14px;
    line-height: 1.4;
  `,
};
